@if (showAlarms) {
  <div class="row">
    <div class="col mb-3">
      <div class="card border border-danger">
        <div class="card-header">
          <div class="row">
            <div class="col-9 font-weight-bold text-primary font-size-normal">
              {{"ALARMS.POPUP.HIGH_PRIORITY" |translate}}
            </div>
            <div class="col-3 order-md-3 d-flex align-items-center justify-content-end">
              <i class="icon-Close clickable" (click)="closeAllAlarms()"></i>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          @if (popupAlarms.length !== 0) {
            <div class="table-wrapper table-responsive">
              <table
                class="table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table text-nowrap">
                <thead>
                  <tr>
                    <th class="pl-3 pr-3">{{"ALARMS.POPUP.TIMESTAMP" |translate}}</th>
                    <th class="pl-3 pr-3">{{"ALARMS.POPUP.TURBINE" |translate}}</th>
                    <th class="pl-3 pr-3">{{"ALARMS.POPUP.CODE" |translate}}</th>
                    <th class="pl-3 pr-3">{{"ALARMS.POPUP.DESCRIPTION" |translate}}</th>
                    <th class="pl-3 pr-3"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (alarm of popupAlarms; track alarm; let i = $index) {
                    <tr class="text-primary clickable">
                      <td class="pl-3 pr-3 ">
                        <a [routerLink]="['/monitor/turbine', alarm.turbine_serial]" class="font-weight-bold"  (click)="gotoTurbine(alarm, i)" >
                          {{ alarm?.createTS | dateTimeFormatPipe: 'dm' }}
                        </a>
                      </td>
                      <td class="pl-3 pr-3">
                        <a [routerLink]="['/monitor/turbine', alarm.turbineSerial]" (click)="gotoTurbine(alarm, i)">
                          {{ alarm?.turbineCode | noUnderscore }} ({{ alarm?.turbineSerial }})
                        </a>
                      </td>
                      <td class="pl-3 pr-3">
                        <a [routerLink]="['/monitor/turbine', alarm.turbine_serial]" (click)="gotoTurbine(alarm, i)">
                          {{ alarm?.code }}
                        </a>
                      </td>
                      <td class="pl-3 pr-3">
                        <a [routerLink]="['/monitor/turbine', alarm.turbine_serial]" (click)="gotoTurbine(alarm, i)">
                          {{ alarm?.description }}
                        </a>
                      </td>
                      <td class="pl-3 pr-3">
                        <i class="icon-Close clickable" (click)="closeSingleAlarm(i)"></i>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
